<template>
	<div>
		<el-dialog :visible.sync="showPoints" width="671px" :close-on-click-modal='false' :show-close="true"
			:close-on-press-escape='false'>
			<div class="dialog">
				<div class="head">
					<div class="tit t-c">我的积分</div>
					<div class="flex flex-b" style="margin-bottom: 10px;">
						<div class="flex">
							<img src="@/assets/images/mine/jf2.png" style="width: 40px;height: 40px;" alt="" />
							<div class="jf">{{userInfo.score}}</div>
						</div>
						<div class="rule pointer" @click="showPointsRule=true">积分规则</div>
					</div>
					<div class="long">已连续登录 <span>{{userInfo.login_day}}</span> 天</div>
					<div class="date">
						<div class="flex flex-b scrollx" style="padding: 0 20px;overflow-x: scroll;">
							<div class="flex flex-column-item">
								<div class="flex flex-b line">
									<div class="t" style="margin-right: 30px;" v-for="(item,index) in dateWeeks.week"
										:key="index">{{item}}</div>
								</div>
								<div class="flex flex-b">
									<div class="flex-column-item" style="margin-top: 10px;margin-right: 30px;"
										v-for="(item,index) in dateWeeks.date">
										<div class="flex-column-item">
											<img src="@/assets/images/mine/jf3.png" v-if="item.is_sign==1"
												style="width: 36px;height: 36px;position: relative;z-index: 88;"
												alt="" />
											<img src="@/assets/images/mine/jf4.png" v-if="item.is_sign==2"
												style="width: 36px;height: 36px;position: relative;z-index: 88;"
												alt="" />
											<div class="add" v-if="item.is_sign==2 && item.isShow">+{{item.score}}</div>
											<div class="add add1" v-if="item.is_sign==2&&!item.isShow">未签</div>
											<div class="add add2" v-if="item.is_sign==1">已签</div>
										</div>
										<div class="time">{{item.date}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="jfList">
					<div class="tabs flex">
						<div class="tabItem pointer" :class="tabIndex==0?'active':''" @click="tabIndex=0">赚积分</div>
						<div class="tabItem pointer" :class="tabIndex==1?'active':''" @click="tabIndex=1">积分明细</div>
					</div>
					<div class="wbox" v-if="tabIndex==0">
						<div class="item flex flex-b" v-for="(item,i) in addPoints">
							<div class="flex">
								<img :src="item.icon" style="width: 53px;height: 53px;margin-right: 10px;" alt="" />
								<div>
									<div class="t1">{{item.name}}</div>
									<!-- <div class="jf">积分<span>+{{item.score}}</span></div> -->
									<div class="jf"><span>{{item.score}}</span></div>
								</div>
							</div>
							<!-- <div class="status pointer" v-if="item.is == 2" @click="$router.push(item.path)">去完成</div>
							<div class="status status1" v-if="item.is==1">已完成</div> -->
							
							<div v-if="item.name == '每日登录'">
								<div class="status status1">已完成</div>
							</div>
							<div v-else-if="item.name == '完成个人信息'">
								<div class="status pointer" v-if="item.is == 2" @click="$router.push(item.path)">去完成</div>
								<div class="status status1" v-if="item.is==1">已完成</div>
							</div>
							<div v-else>
								<div class="status pointer" @click="$router.push(item.path)">去完成</div>
							</div>
						</div>
					</div>
					<div class="wbox" v-if="tabIndex==1">
						<div class="item" v-for="(item,i) in scoreLogList">
							<div class="flex flex-b">
								<div class="t2">{{item.content}}</div>
								<div class="t3">{{item.score>0?'+'+item.score:item.score}}</div>
							</div>
							<div class="flex flex-b">
								<div class="time">{{item.create_time}}</div>
								<div class="time">余额 {{item.left_score}} </div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>

		<!-- 积分规则 -->
		<el-dialog :visible.sync="showPointsRule" width="50%" :close-on-click-modal='false' :show-close="true"
			:close-on-press-escape='false'>
			<div class="dialog">
				<div class="tit t-c">积分规则</div>
				<div class="box" style="padding: 0 20px 20px;">
					<!-- <div class="text">此页为富文本</div>
					<div class="titles">在S学院如何获取积分？</div> -->
					<div class="t" v-html="ruleData.value"></div>
					<!-- <img src="@/assets/images/home/logo.png"
						style="width: 383px;height: 222px;border-radius: 20px;margin: 6px 0;" alt="" />
					<div class="t">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum
						laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales
						pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur
						ridiculus mus. 
						Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin
						gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.
						Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. </div> -->
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Utils from "@/jslibs/utils";
	import {
		getMyCourse,
		getUser,
		EditUser,
	} from '@/api/mine';
	import {
		getConfigList,
		getUserScoreList,
		getUserScoreTask,
		getSign
	} from '@/api/points';
	import {
		getConfigDetail
	} from '@/api/common';
	export default {
		data() {
			return {
				showPointsRule: false, //积分规则弹窗
				showPoints: false, //我的积分
				dateWeeks: {
					week: [],
					date: []
				},
				dateList: ['日', '一', '二', '三', '四', '五', '六'],
				tabIndex: 0,
				addPoints: [{
						icon: require('@/assets/images/mine/imine1.png'),
						name: '每日登录',
						score: 0,
						is: 2,
						obj: 'login'
					}, {
						icon: require('@/assets/images/mine/imine2.png'),
						name: '邀请用户',
						score: 0,
						is: 2,
						path: '/invite',
						obj: 'invite'
					}, {
						icon: require('@/assets/images/mine/imine3.png'),
						name: '完成章节学习',
						score: 0,
						is: 2,
						path: '/allCourse',
						obj: 'chapter_study'
					}, {
						icon: require('@/assets/images/mine/imine4.png'),
						name: '分享已购课程',
						score: 0,
						is: 2,
						path: '/allCourse',
						obj: 'share_course'
					}, {
						icon: require('@/assets/images/mine/imine5.png'),
						name: '评论已购课程',
						score: 0,
						is: 2,
						path: '/allCourse',
						obj: 'evaluate'
					}, {
						icon: require('@/assets/images/mine/imine6.png'),
						name: '线下培训签到',
						score: 0,
						is: 2,
						path: '/myTraining',
						obj: 'train_sign'
					},
					{
						icon: require('@/assets/images/mine/imine5.png'),
						name: '完成个人信息',
						score: 0,
						is: 2,
						path: '/mine',
						obj: 'user_info'
					},
				],
				ruleData: '',
				loginUser: '',
				userInfo: '',
				scoreLogList: []
			}
		},
		mounted() {
			if (Utils.getCookie('loginUser')) {
				this.loginUser = JSON.parse(Utils.getCookie('loginUser'))
				this.getUser()
			}
			// const dateList = this.generateDateList();
			this.getConfigDetail()
			this.getUserScoreList()
			this.getUserScoreTask()
			this.getSign()
		},
		methods: {
			async getSign() {
				const {
					status,
					data
				} = await getSign({})
				// console.log(data,9123)
				var currentDate = new Date();
				var year = currentDate.getFullYear();
				let nowDate = this.formatDate(new Date())
				var year = currentDate.getFullYear();
				let findIndex = data.result.findIndex(item=>{
					return item.date == nowDate.replace('.','-')
				})
				data.result.forEach((item,index) => {
					this.dateWeeks.week.push(this.getWeekday(new Date(year + '-' + item.date)))
					this.dateWeeks.date.push({
						date: this.formatDate(new Date(year + '-' + item.date)),
						is_sign: item.is_sign,
						isShow:index<findIndex?false:true,
						score: item.score
					})
				})
			},
			async getUserScoreTask() {
				const {
					status,
					data
				} = await getUserScoreTask({})
				this.addPoints.forEach(item => {
					item.score = data.result[item.obj] ? data.result[item.obj].score : 0
					item.is = data.result[item.obj] ? data.result[item.obj].is : 2
				})
			},
			async getUserScoreList() {
				const {
					status,
					data
				} = await getUserScoreList({
					page_index: 1,
					page_size: 9999
				})
				this.scoreLogList = data.result.data
			},
			async getConfigDetail() {
				const {
					status,
					data
				} = await getConfigDetail({
					key: 'SCORE_RULE'
				})
				this.ruleData = data.result
			},
			async getUser() {
				const {
					status,
					data
				} = await getUser({})
				this.userInfo = data.result
			},
			formatDate(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				return `${month}.${day}`;
			},
			getWeekday(date) {
				const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
				return `${weekdays[date.getDay()]}`;
			},
			// generateDateList() {
			// 	const today = new Date();
			// 	for (let i = 7; i >= 0; i--) {
			// 		const date = new Date(today);
			// 		date.setDate(date.getDate() - i);
			// 		this.dateWeeks.week.push(this.getWeekday(date))
			// 		this.dateWeeks.date.push(this.formatDate(date))
			// 	}
			// },
			openDialog() {
				this.showPoints = true
			},
		}
	}
</script>

<style scoped lang="less">
	/deep/ .el-dialog__header {
		padding: 0 !important;
	}

	/deep/ .el-dialog__body {
		padding: 0 !important;
	}

	::v-deep .el-dialog__close:hover {
		color: #999;
	}

	::v-deep .el-dialog__headerbtn {
		font-size: 24px;
	}

	.dialog {
		background: #fff;
		border-radius: 10px;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #CCCCCC;
		}

		.tit {
			line-height: 60px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 20px;
			color: #000000;
		}

		.t {

			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #333333;
		}

		.head {
			width: 671px;
			height: 340px;
			background-image: url('../assets/images/mine/jfBg.png');
			background-size: 100%;
			padding: 0 30px;

			.jf {
				margin-left: 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: bold;
				font-size: 31px;
				color: #00A73C;
			}

			.rule {
				margin-right: 200px;
				height: 27px;
				padding: 0 6px;
				background: #A8C9B4;
				border-radius: 11px 11px 11px 11px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #FFFFFF;
				line-height: 27px;
			}

			.long {
				margin-top: -40px;
				width: 100%;
				height: 62px;
				background-image: url('../assets/images/mine/longBg.png');
				background-size: 100%;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 18px;
				color: #000000;
				padding: 20px;
				text-align: right;

				span {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 18px;
					color: #00A73C;
				}
			}

			.date {
				background: #FFFFFF;
				border-radius: 0 0 20px 20px;
				padding: 0 20px 20px;

				.line {
					width: 101%;
					height: 31px;
					background: #F7F7F7;
					border-radius: 9px 9px 9px 9px;
					padding: 0 30px;
				}

				.add {
					width: 50px;
					margin-top: -20px;
					padding: 24px 0 10px;
					background: #F7F7F7;
					border-radius: 9px 9px 9px 9px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					text-align: center;
					font-weight: 500;
					font-size: 13px;
					color: #BABABC;

					&.add1 {
						border: 1px solid #C2EAD0;
						background: transparent;
						white-space: nowrap;
						color: rgba(0, 167, 60, 0.56);
					}

					&.add2 {
						background: #00A73C;
						color: #FFFFFF;
					}
				}

				.time {
					margin-top: 6px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #EACF8C;
				}
			}
		}

		.jfList {
			padding: 20px;

			.tabs {
				padding: 0 80px;
				margin-bottom: 20px;
				align-items: center;
				justify-content: space-around;

				.tabItem {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 18px;
					color: #666666;
				}

				.active {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 18px;
					color: #000000;
					position: relative;
					z-index: 2;

					&::after {
						position: absolute;
						content: '';
						z-index: -1;
						bottom: 4px;
						left: 0;
						width: 53px;
						height: 4px;
						background: linear-gradient(141deg, #10B649 0%, #7FDA4C 100%);
					}
				}
			}

		}

		.wbox {
			height: 350px;
			overflow-y: scroll;
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 0 20px;

			.item {
				padding: 14px 0;
				border-bottom: 1px solid #EEEEEE;

				&:last-child {
					border-bottom: none;
				}

				.t1 {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 18px;
					color: #000000;
				}

				.jf {
					margin-top: 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #000000;

					span {
						margin-left: 4px;
						color: #00A73C;
					}
				}

				.status {
					height: 36px;
					line-height: 36px;
					background: linear-gradient(136deg, #7FDA4C 0%, #10B649 100%);
					border-radius: 11px 11px 11px 11px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 16px;
					color: #FFFFFF;
					padding: 0 16px;

					&.status1 {
						background: #CCCCCC;
					}
				}

				.t2 {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
				}

				.t3 {
					font-family: DINPro, DINPro;
					font-weight: bold;
					font-size: 18px;
					color: #333333;
				}

				.time {
					margin-top: 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #999999;
				}
			}
		}
	}

	.scrollx {
		scrollbar-width: thin;
		/* 设置滚动条的宽度 */
		scrollbar-color: #888 #f1f1f1;
		/* 设置滚动条的颜色 */
	}

	.scrollx:hover {
		scrollbar-color: #555 #f1f1f1;
		/* 设置滚动条的悬停颜色 */
	}
	.t{
		::v-deep img{
			width: 100%;
		}
	}
</style>